import { range } from 'lodash';
import { CircleIcon } from 'lucide-react-native';
import { View, XStack } from 'tamagui';

import { Icon } from '../icons/Icon';

interface DotNavigationProps {
    total: number;
    currentIndex: number;
    onSelectIndex?: (index: number) => void;
}

export const DotNavigation = ({
    total,
    currentIndex,
    onSelectIndex,
}: DotNavigationProps) => {
    return (
        <XStack justifyContent="center" marginBottom={8}>
            {range(total).map((i) => (
                <View
                    key={i}
                    margin={1}
                    padding={3}
                    onPress={() => {
                        onSelectIndex?.(i);
                    }}
                    cursor="pointer"
                    borderRadius={100}
                    borderWidth={1}
                    borderColor="transparent"
                    hoverStyle={{ borderColor: '$gray400' }}
                >
                    <Icon
                        icon={CircleIcon}
                        size={8}
                        color={currentIndex === i ? '$black' : '$gray400'}
                    />
                </View>
            ))}
        </XStack>
    );
};
